<section>
  <h3>Ticket {{ status }}</h3>
  <p>{{ message }}</p>
  <app-primary-button class="w-100" [block]="true" (click)="navigateHome()">Ok</app-primary-button>
</section>
